import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Services,
  Portfolios,
  Advantages,
  Testimonials,
  Certificates,
} from "json/landingPageData";
import Header from "parts/Header";
import Hero from "parts/Hero";
import Service from "parts/Service";
import Portfolio from "parts/Portfolio";
import Advantage from "parts/Advantage";
import Testimonial from "parts/Testimonial";
import Certificate from "parts/Certificate";
import Discuss from "parts/Discuss";
import Footer from "parts/Footer";

const LandingPage = () => {
  const location = useLocation(); // Get current URL

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on page load

    // Scroll to section if there's a hash (e.g., #part2)
    if (location.hash) {
      setTimeout(() => {
        const section = document.querySelector(location.hash);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]); // Runs when location changes

  return (
    <>
      <Header />
      <Hero />
      <Service data={Services} />
      <Portfolio data={Portfolios} />
      <Advantage data={Advantages} />
      <Certificate data={Certificates} />
      <Testimonial data={Testimonials} />
      <Discuss />
      <Footer />
    </>
  );
};

export default LandingPage;
